import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { DatepickerRange, MultiselectItem, TableListItem } from '@ui/aos-lib';
import type { AlarmStatisticResponse } from '../../alarms/services/alarms.types';
import type {
  BatteryStatistic,
  HealthMonitorFilter,
  HealthMonitorFilterChip,
  HealthStatistic,
  ReadRateStatistic,
  ReadSuccessRateStatistic
} from '../health-monitor.types';
import { ReportGroupFilterResponse } from 'src/app/services/api/report-group-filter/report-group-filter-api.types';
import { UserConfigHealthMonitorFilters } from '../health-api.types';
import { EquipmentListingFieldName } from '../../devices/components/devices.models';

export const HealthMonitorActions = createActionGroup({
  source: 'Health Monitor',
  events: {
    // Filters init
    'Get Persisted Filters State': emptyProps(),
    'Get Filters And Init Filters State': props<{ filtersState: UserConfigHealthMonitorFilters | null }>(),
    'Get Filters And Init Filters State Success': props<{
      reportGroups: ReportGroupFilterResponse[];
      filtersState: UserConfigHealthMonitorFilters | null;
    }>(),
    'Get Filters And Init Filters State Failure': props<{ error: string }>(),
    'Save Persisted Filters State': emptyProps(),

    // Device types filter counts
    'Get Filters Count': emptyProps(),
    'Update Filters Count': emptyProps(),
    'Get Filters Count Success': props<{ filters: HealthMonitorFilter[] }>(),
    'Get Filters Count Failure': props<{ error: string }>(),

    // Read rate
    'Get Read Rate Statistic Success': props<{ readRateStatistic: ReadRateStatistic }>(),
    'Get Read Rate Statistic Failure': props<{ error: string }>(),

    // Read success rate
    'Get Read Success Rate Statistic Success': props<{ readSuccessRateStatistic: ReadSuccessRateStatistic }>(),
    'Get Read Success Rate Statistic Failure': props<{ error: string }>(),

    // Battery
    'Get Health Battery Statistic Success': props<{
      batteryStatistic: BatteryStatistic;
      batteryDevicesIsNotEmpty: boolean;
    }>(),
    'Get Health Battery Statistic Failure': props<{ error: string }>(),

    // Health statuses (overall health widget)
    'Get Health Statuses Success': props<{ healthStatuses: HealthStatistic }>(),
    'Get Health Statuses Failure': props<{ error: string }>(),

    // History log
    'Get History Log': props<{ date: DatepickerRange | null }>(),
    'Get History Log Success': props<{ historyLog: TableListItem[] }>(),
    'Get History Log Failure': props<{ error: string }>(),

    // Alarm statistics
    'Get Alarm Statistics': props<{ date: DatepickerRange | null }>(),
    'Get Alarm Statistics Success': props<{ alarmStatistics: AlarmStatisticResponse }>(),
    'Get Alarm Statistics Failure': props<{ error: string }>(),

    // UI / sync
    'Update Chips': props<{ chip: HealthMonitorFilterChip }>(),
    'Clear Chips': emptyProps(),
    'Update Filter': props<{ filterType: EquipmentListingFieldName; items: MultiselectItem[] }>(),
    'Reset Filter': emptyProps(),
    'Dcu Filter Activate': emptyProps(),
    'Reset State': emptyProps(),
    'Update Alarms Date Range': props<{ alarmsDateRange: DatepickerRange }>(),
    'Update History Date Range': props<{ historyLogDateRange: DatepickerRange }>()
  }
});
